import { render } from "./FollowUpRating.vue?vue&type=template&id=96f5e9e4&scoped=true"
import script from "./FollowUpRating.vue?vue&type=script&lang=js"
export * from "./FollowUpRating.vue?vue&type=script&lang=js"

import "./FollowUpRating.vue?vue&type=style&index=0&id=96f5e9e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96f5e9e4"]])

export default __exports__